
/**
 * 메시지 상태 정보
 */
export type MessagingGetChatRooms200PageAllOfThreeContentItemLastMessageStatus = {
  isRead?: boolean;
};
